import { useEffect } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import RootLayoutWrapper from 'app/[lang]/layout'
import { languages, detectBrowserLanguage } from '@/lib/i18n/settings'

/**
 * Layout for the `:lang` segment: validates the language param, syncs i18n to it,
 * and renders the app's root wrapper. Extracted from the route table so routes.ts
 * can stay JSX-free.
 */
export function LanguageLayout() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (lang) {
      if (!(languages as readonly string[]).includes(lang)) {
        // If the first segment is not a language, redirect to default language
        const detectedLang = detectBrowserLanguage()
        navigate(`/${detectedLang}/${lang}${location.pathname.substring(lang.length + 1)}${location.search}`, { replace: true })
        return
      }
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang)
      }
    }
  }, [lang, i18n, navigate, location])

  if (lang && !(languages as readonly string[]).includes(lang)) {
    return null
  }

  return (
    <RootLayoutWrapper>
      <Outlet />
    </RootLayoutWrapper>
  )
}
